import { heroStats, quickEntries } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20torn%20paper%20layers%20vintage%20archive%20folders%20and%20ink%20smudges%20on%20textured%20off-white%20paper%20background%2C%20muted%20vermillion%20and%20warm%20amber%20tones%2C%20film%20grain%20texture%2C%20moody%20vignette%2C%20stylized%20artistic%20composition%20with%20strong%20contrast%20for%20overlay%20text%2C%20no%20text%2C%20no%20faces%2C%20cinematic%20editorial%20magazine%20cover%20aesthetic&width=1920&height=1080&seq=hlc-hero-main&orientation=landscape"
          alt="黑料91黑料仓库专题合集封面"
          title="黑料91黑料仓库 专题合集归档"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/75" />
      </div>

      <div className="relative mx-auto w-full max-w-[1440px] px-4 pb-36 pt-20 text-center md:px-6 md:pb-44 md:pt-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs tracking-[0.2em] text-white/85 backdrop-blur-sm">
          <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-300">
            <i className="ri-folder-shield-2-line text-sm" />
          </span>
          黑料91 · 专题合集仓库
        </span>

        <h2 className="mx-auto mt-6 max-w-3xl font-heading text-3xl font-bold leading-snug tracking-wide text-white md:text-5xl">
          把散落的黑料，一次收进一个仓库
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/75 md:text-base">
          黑料91黑料仓库按主题、标签和来源把分散内容集中收纳，页内顺着目录或关键词查找更快，
          省去反复翻页和到处收集的麻烦。
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-2.5 md:gap-3">
          {quickEntries.map((entry) => (
            <a
              key={entry.label}
              href={entry.href}
              className="group flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2.5 text-sm text-white backdrop-blur-sm transition-colors hover:bg-white/20 cursor-pointer whitespace-nowrap"
            >
              <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                <i className={`${entry.icon} text-base`} />
              </span>
              {entry.label}
              <span className="font-label text-[11px] text-white/55">{entry.hint}</span>
              <i className="ri-arrow-right-up-line text-white/40 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          ))}
        </div>

        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-white/15 bg-white/10 px-3 py-3.5 backdrop-blur-sm"
            >
              <p className="font-label text-xl font-semibold text-white md:text-2xl">
                {stat.value}
                <span className="ml-0.5 text-xs font-normal text-white/60">{stat.unit}</span>
              </p>
              <p className="mt-1 text-xs text-white/65">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}